import { useEffect } from 'react';

import useNavigation from '@/hooks/useNavigation';
import { useAdminRoute } from '@/pages/corporate/routes/hooks/useAdminRoutes';

import { BreadcrumbHistory, useBreadcrumbContext } from '../Breadcrumb/context';
import calledOnlyOnce from './utils/calledOnlyOnce';
import { usePageLayoutContext } from './context';
import { PageLayoutType } from './types';
import { DEFAULT_VALUE } from './';

const usePageLayout = (params: PageLayoutType) => {
  const navigation = useNavigation();
  const isAdminRoute = useAdminRoute();
  const { setHeaderProps } = usePageLayoutContext();
  const { setBreadcrumbHistory, breadcrumbs, setBreadcrumb } = useBreadcrumbContext();

  calledOnlyOnce(navigation.pathname);

  useEffect(() => {
    setHeaderProps({ ...DEFAULT_VALUE, ...params, pageId: null, module: null });
  }, [params, setHeaderProps]);

  useEffect(() => {
    return () => setBreadcrumb([]);
  }, [setBreadcrumb]);

  useEffect(() => {
    return () => {
      const headerProps = isAdminRoute ? { ...DEFAULT_VALUE, showHeader: false } : DEFAULT_VALUE;
      setHeaderProps(headerProps);
    };
  }, [isAdminRoute, setHeaderProps]);

  useEffect(() => {
    if (!params.title || !params.pageId) {
      return;
    }

    setBreadcrumbHistory((prevBreadcrumbHistory: BreadcrumbHistory) => {
      if (
        prevBreadcrumbHistory[params.pageId]?.id &&
        prevBreadcrumbHistory[params.pageId]?.path == navigation.asPath
      )
        return prevBreadcrumbHistory;

      return {
        ...prevBreadcrumbHistory,
        [params.pageId]: {
          id: params.pageId,
          pageTitle: params.title,
          path: navigation.asPath,
          module: params.module,
          query: navigation.query,
        },
      } as BreadcrumbHistory;
    });
  }, [
    breadcrumbs,
    navigation.asPath,
    navigation.pathname,
    navigation.query,
    params.pageId,
    params.module,
    params.title,
    setBreadcrumbHistory,
  ]);
};

export default usePageLayout;
